import { MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { PortfolioPortalSyncHistoryOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { PortalSyncBaseComponent } from "./PortalSync/PortalSyncBaseComponent";
import { PortfolioSaveOptionKey } from "./PortfolioSaveOptionKey";

class PortalSyncHistory extends PortalSyncBaseComponent {
    protected getSaveOptionKey(): string {
        return PortfolioSaveOptionKey.PortalSyncHistory;
    }

    protected showStatusFilters(): boolean {
        return false;
    }

    protected getMyleTableColumnsOptions(): MyleTableColumnOptions[] {
        return [
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PatientLabel"),
                FieldName: "PatientName",
                WidthPercentageDefault: 15
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PhoneLabel"),
                FieldName: "PatientPhoneNumbers",
                WidthPercentageDefault: 15,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("ItemLabel"),
                FieldName: "SyncItemName",
                WidthPercentageDefault: 18,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("DateLabel"),
                FieldName: "SyncDate",
                WidthPercentageDefault: 12,
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: PortfolioPortalSyncHistoryOrderType.SyncDate,
                SortDirection: SortDirection.DESC
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("UserLabel"),
                FieldName: "SyncUser",
                WidthPercentageDefault: 12,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("StatusLabel"),
                FieldName: "SyncStatus",
                WidthPercentageDefault: 8,
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: PortfolioPortalSyncHistoryOrderType.Status,
                SortDirection: SortDirection.DESC
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("ViewedLabel"),
                FieldName: "ViewedDate",
                WidthPercentageDefault: 12,
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: PortfolioPortalSyncHistoryOrderType.ViewDate,
                SortDirection: SortDirection.DESC
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PortalLabel"),
                FieldName: "PortalStatus",
                WidthPercentageDefault: 8,
                RowClickEnabled: true
            })
        ];
    }
}

export { PortalSyncHistory };
